import { Button, Form, Modal } from "antd";
import React, { useEffect, useState } from "react";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import Done from "../../../../Assets/svg/done.svg";
import exclamationMark from "../../../../Assets/svg/exclamationMark.svg";
import { httpService } from "../../../../services/httpService.service";
import TextArea from "antd/es/input/TextArea";
import { CloseOutlined } from "@ant-design/icons";

const RejectModal = ({
  visible,
  onClose,
  onOk,
  setMessage,
  siteVisitCardId,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleChangeConfirm = () => {
    if (!siteVisitCardId) {
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const rejectReason = values.rejectReason;
        setLoading(true);
        httpService.put(
          `/api/Site/changeSiteVisitApprovalStatus?SiteVisitId=${siteVisitCardId}&ApprovalStatus=3&RejectionReason=${rejectReason}`,
          "",
          (res) => {
            const message =
              res?.message || "You have successfully updated site visit files!";
            setMessage({
              trigger: true,
              type: "success",
              icon: Done,
              title: `Site visit updated successfully!`,
              text: message,
            });

            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);
            setLoading(false);
            onOk();
            onClose();
          },
          (error) => {
            const errorMessage =
              error?.errors?.[0]?.message ||
              error?.message ||
              "Failed to update this site visit. Please try again later!";

            setMessage({
              trigger: true,
              type: "danger",
              icon: exclamationMark,
              title: "Update Failed",
              text: errorMessage,
            });

            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);
            setLoading(false);
          }
        );
      })
      .catch((error) => {
        // console.log(error?.errorFields[0]);
      });
  };

  return (
    <Modal
      title={
        <div className="d-flex flex-row align-items-center">
          <h2 className="modalHeader m-0 p-0">Reject Site Visit</h2>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={onClose}
              alt="cancelX"
            />
          </div>
        </div>
      }
      closable={false}
      open={visible}
      onCancel={onClose}
      width={700}
      footer={[
        <Button
          key="submit"
          onClick={onOk}
          className="inviteButtonTPM"
          loading={loading}
        >
          Cancel
        </Button>,

        <Button
          onClick={handleChangeConfirm}
          className="addButtonTPM"
          loading={loading}
        >
          <CloseOutlined color="#fff" />
          Reject
        </Button>,
      ]}
    >
      <Form key={siteVisitCardId} form={form} layout="vertical">
        <Form.Item
          name="rejectReason"
          label="Reject Reason"
          className="my-5"
          rules={[
            { required: true, message: "Please give a reason of reject!" },
          ]}
        >
          <TextArea
            placeholder="Please give a reason of reject!"
            style={{ height: "100px" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectModal;
